export default "__VITE_ASSET__BNh2fnn$__"